import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { selectJbpSettingsBusinessUnitOptions } from 'legacy/lut/features/partner360/jbpSettings/selectors/selectJbpSettingsBusinessUnitOptions'
import { useStaticCrud } from 'legacy/lut/hooks/useStaticCrud'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { FormMultiselect } from 'cng-common/features/form'

import { HP_CONTACT_REQUEST_EDITOR_FORM } from '../../config'

interface IBusinessUnitMultiSelectProps {
  defaultValue: string[]
  popPaperClassName?: string
  disabled?: boolean
}

export const BusinessUnitMultiSelect: FC<IBusinessUnitMultiSelectProps> = ({
  defaultValue,
  popPaperClassName,
  disabled,
}) => {
  const options = useSelector(selectJbpSettingsBusinessUnitOptions)

  const crud = useStaticCrud({
    items: options,
    keyField: 'BusinessUnit',
  })

  const handleValidation = useCallback(
    async (value: string) => {
      return ValidationHelper.checkMultiselect(value, options, 'BusinessUnit', '/')
    },
    [options]
  )

  return (
    <FormMultiselect
      formKey={HP_CONTACT_REQUEST_EDITOR_FORM}
      field="BusinessUnit"
      label={'Business Unit'}
      caption={'BusinessUnit'}
      classes={{
        controlClasses: {
          popPaper: popPaperClassName,
        },
      }}
      defaultValue={defaultValue}
      source={crud}
      disabled={disabled}
      checkFn={handleValidation}
    />
  )
}
